import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';

export interface IExtractFailureNotificationParams extends IResult {
  id: string;
  contentType: string;
}

export class ExtractFailureNotificationOptInRequest extends Request<IExtractFailureNotificationParams, IResult> {
  constructor(id: string, contentType: string) {
    super('optInToExtractFailureNotificationsForContent', {
      id: id,
      contentType: contentType
    });
  }
}

export class ExtractFailureNotificationOptOutRequest extends Request<IExtractFailureNotificationParams, IResult> {
  constructor(id: string, contentType: string) {
    super('optOutOfExtractFailureNotificationsForContent', {
      id: id,
      contentType: contentType
    });
  }
}